import { EditorState } from 'draft-js'
import { Map } from 'immutable'

export type TaskState = {
  conspectKeys: string[]
  solutionKeys: string[]
  decisionKeys: string[]
  conspectBlocksLength: number
  solutionBlocksLength: number
  conspectTextLength: number
  solutionTextLength: number
  decisionValue: null | 'do' | 'dontdo' | 'timeout'
}
export default class TaskStateClass {
  static fromEditorState(editorState: EditorState) {
    const content = editorState.getCurrentContent()
    const blocks = content.getBlocksAsArray()

    const tasks = blocks.reduce(
      (acc, block, index, blocks) => {
        let isDecisionBefore = false

        if (index > 0) {
          const blockBefore = blocks[index - 1]
          isDecisionBefore = blockBefore.get('data').get('type') === 'decision'
        }
        let currentTask

        if (isDecisionBefore) {
          currentTask = getEmptyTask()
          acc.push(currentTask)
        } else {
          currentTask = acc[acc.length - 1]
        }

        const key: string = block.get('key')
        const type = block.get('data').get('type')
        if (type === 'conspect') {
          if (currentTask.solutionKeys.length > 0) {
            currentTask.solutionKeys.push(key)
            currentTask.solutionTextLength += block.getLength()
          } else {
            currentTask.conspectKeys.push(key)
            currentTask.conspectTextLength += block.getLength()
          }
        } else if (type === 'solution') {
          currentTask.solutionKeys.push(key)
          currentTask.solutionTextLength += block.getLength()
        } else if (type === 'decision') {
          currentTask.decisionKeys.push(key)
          const data = block.get('data') as Map<string, string>
          if (data && data.has('selected')) {
            currentTask.decisionValue = data.get('selected') as 'do' | 'dontdo' | 'timeout' | null
          }
        } else if (currentTask.solutionKeys.length > 0) {
          currentTask.solutionKeys.push(key)
          currentTask.solutionTextLength += block.getLength()
        } else if (currentTask.conspectKeys.length > 0) {
          currentTask.solutionKeys.push(key)
          currentTask.solutionTextLength += block.getLength()
        }
        return acc
      },
      [getEmptyTask()]
    )

    return tasks
  }

  static getTaskByKey = (taskState: TaskState[], key: string) => {
    const result = taskState.find(task => {
      return (
        task.conspectKeys.indexOf(key) !== -1 ||
        task.solutionKeys.indexOf(key) !== -1 ||
        task.decisionKeys.indexOf(key) !== -1
      )
    })

    if (!result) {
      throw new Error('coudnt find task by key')
    }

    return result
  }

  static getBlockTaskType = (task: TaskState, key: string) => {
    if (task.conspectKeys.indexOf(key) !== -1) {
      return 'conspect'
    } else if (task.solutionKeys.indexOf(key) !== -1) {
      return 'solution'
    } else if (task.decisionKeys.indexOf(key) !== -1) {
      return 'decision'
    } else {
      throw new Error('Could not find block type')
    }
  }

  static isTaskBlockEmpty = (task: TaskState, key: string) => {
    const taskBlock = TaskStateClass.getBlockTaskType(task, key)
    return task[`${taskBlock}TextLength`] === 0
  }

  static isOnlyOneKeyInTaskBlock = (task: TaskState, key: string) => {
    const taskBlock = TaskStateClass.getBlockTaskType(task, key)
    return task[`${taskBlock}Keys`].length === 1
  }

  static getTasksWithoutSolution = (taskState: TaskState[]) => taskState.filter(task => task.solutionKeys.length === 0)
  static getTasksWithoutDecision = (taskState: TaskState[]) => taskState.filter(task => task.solutionKeys.length === 0)
  static isTaskTextEmpty = (task: TaskState) => task.conspectTextLength + task.solutionTextLength === 0
  static getLastConspectKey = (task: TaskState) => task.conspectKeys[task.conspectKeys.length - 1]
  static getDecisionBlockKey = (task: TaskState) => task.decisionKeys[0]
  static getFirstBlockInTask = (task: TaskState) => task.conspectKeys[0]
}

const getEmptyTask = (): TaskState => ({
  conspectKeys: [],
  solutionKeys: [],
  decisionKeys: [],
  conspectBlocksLength: 0,
  solutionBlocksLength: 0,
  conspectTextLength: 0,
  solutionTextLength: 0,
  decisionValue: null
})



// WEBPACK FOOTER //
// ./src/editor-helpers/TaskState/TaskState.ts